import axios from "axios";
import * as ActionType from "./sourcingRequest.type";
import { apiInstanceFetch } from "../../../util/api";
import { setToast } from "../../../util/toast";

export const getSourcingRequests = (status = "") => (dispatch) => {
  const url = status
    ? `sourcingRequest/getAll?status=${status}`
    : `sourcingRequest/getAll`;

  apiInstanceFetch
    .get(url)
    .then((res) => {
      dispatch({
        type: ActionType.GET_SOURCING_REQUESTS,
        payload: res.sourcingRequests || [],
      });
    })
    .catch((error) => console.error(error));
};

export const updateSourcingRequestStatus = (requestId, data) => (dispatch) => {
  axios
    .patch(`sourcingRequest/updateStatus?requestId=${requestId}`, data)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.UPDATE_SOURCING_REQUEST,
          payload: { data: res.data.sourcingRequest, id: requestId },
        });
        setToast("success", "Sourcing request updated successfully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => {
      console.log("error", error.message);
      setToast("error", "Failed to update sourcing request");
    });
};

export const sendQuote = (requestId, data) => (dispatch) => {
  axios
    .patch(`sourcingRequest/sendQuote?requestId=${requestId}`, data)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.UPDATE_SOURCING_REQUEST,
          payload: { data: res.data.sourcingRequest, id: requestId },
        });
        setToast("success", "Quote sent to customer successfully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => {
      console.log("error", error.message);
      setToast("error", "Failed to send quote");
    });
};

export const deleteSourcingRequest = (id) => (dispatch) => {
  axios
    .delete(`sourcingRequest/delete?requestId=${id}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: ActionType.DELETE_SOURCING_REQUEST, payload: id });
        setToast("success", "Sourcing request deleted successfully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => {
      console.log("error", error.message);
      setToast("error", "Failed to delete sourcing request");
    });
};
